<template>
    <v-container fill-height>
        <v-dialog persistent v-model="showLoginDialog" max-width="300px">
            <v-card>
                <v-card-text>
                    <v-form @keypress.native.enter="login">
                        <v-text-field label="Bruker" v-model="username" required
                                      :error-messages="errors.username">
                        </v-text-field>
                        <v-text-field label="Passord" v-model="password" type="password" required
                                      :error-messages="errors.password">
                        </v-text-field>
                        <v-btn large block color="primary" :loading="loading" @click="login">Logg inn</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {jwtAuth} from "../helpers";

    export default {
        data() {
            return {
                showLoginDialog: true,
                loading: false,

                username: '',
                password: '',

                errors: {},
            };
        },

        methods: {
            login() {
                jwtAuth(this.username, this.password).then(isOk => {
                    if (isOk) {
                        this.$router.push({name: 'Index'});
                        this.$snackbar.info('Velkommen!');
                    } else {
                        this.errors = {
                            username: 'Feil brukernavn og eller passord.'
                        }
                        this.$snackbar.info('Feil brukernavn og / eller passord.');
                    }
                });
            }
        }
    }
</script>

